<div class="horizontal-selector-container">
  <div class="selector-row flex-wrap">
    <!-- All Selections (You + Competitors) -->
    @for (item of selectedItems; track $index; let i = $index) {
    <div class="selector-item" [matTooltip]="getTooltipForItem(item, i)"
              [matTooltipPosition]="'above'"
              [matTooltipShowDelay]="500">

      <!-- Primary: show as chip only (search input hidden per UI) -->
      @if (i === 0 && showPrimaryDropdown) {
      <div class="input-chip" [matTooltip]="getTooltipForItem(item, 0)"
              [matTooltipPosition]="'above'" [matTooltipShowDelay]="500">
        <div class="chip-content">
          <div class="color-indicator" [style.background-color]="item.color"></div>
          <!-- Hidden: primary search field - show simple chip text only
          <mat-form-field appearance="outline" class="inline-input">
            <input matInput [(ngModel)]="primarySearchInput" (input)="onPrimarySearchChange($any($event.target).value)"
              (keyup.enter)="onPrimaryOptionSelected(primarySearchInput)" placeholder="Type to search..."
              [matAutocomplete]="primaryAuto">
            <mat-autocomplete #primaryAuto="matAutocomplete"
              (optionSelected)="onPrimaryOptionSelected($event.option.value)">
              @for (option of filteredPrimaryOptions; track $index) {
              <mat-option [value]="option">{{ option }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <button mat-icon-button class="remove-button" (click)="showPrimaryDropdown = false; activeInputIndex = -1">
            <mat-icon>close</mat-icon>
          </button>
          -->
          <span class="chip-text">{{ item.name || '' }}</span>
        </div>
      </div>
      }
      
      <!-- Competitor Selection Input Field (in place) -->
      <!-- @if (i > 0 && showAddField && activeInputIndex === i) {
      <div class="input-chip">
        <div class="chip-content">
          <div class="color-indicator" [style.background-color]="item.color"></div>
          <mat-form-field appearance="outline" class="inline-input">
            <input matInput [(ngModel)]="newCompetitorInput"
              (input)="onCompetitorInputChange($any($event.target).value)"
              (keyup.enter)="onCompetitorSelected(newCompetitorInput)" placeholder="Type to search..."
              [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onCompetitorSelected($event.option.value)">
              @for (option of filteredOptions; track $index) {
              <mat-option [value]="option">
                {{ option }}
              </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <button mat-icon-button class="remove-button" (click)="showAddField = false; activeInputIndex = -1">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      } -->

      <!-- Regular Chip (when not showing input) -->
      @if (!(i === 0 && showPrimaryDropdown) && !(i > 0 && showAddField && activeInputIndex === i)) {
      <div class="selection-chip" 
           [class.primary-chip]="i === 0"
           [class.competitor-chip]="i > 0"
           (click)="i === 0 ? onPrimaryChipClick() : (i > 0 && !item.name ? onAddCompetitor() : null)">
        <div class="chip-content">
          <div class="color-indicator" [style.background-color]="item.color"></div>
          <span class="chip-text">{{ item.name || (i === 0 ? '' : 'Add competitor') }}</span>
          @if (entityType === 'brand' && i > 0 && item.name) {
          <button
            mat-icon-button
            class="remove-button"
            type="button"
            (click)="onRemoveItem(item, i); $event.stopPropagation()"
            matTooltip="Remove competitor and re-analysis"
            matTooltipPosition="above">
            <mat-icon>close</mat-icon>
          </button>
          }
        </div>
      </div>
      }
    </div>
    }

    <!-- Add competitor buttons hidden per UI (preserved for re-enable)
    @if (selectedItems.length === 1 && selectedItems.length < maxCompetitors) {
      <div class="selector-item">
      <div class="add-competitor-chip" (click)="onAddCompetitor()" matTooltip="Add competitor" matTooltipPosition="below">
        <div class="chip-content">
          <mat-icon class="add-icon">add</mat-icon>
          <span class="chip-text placeholder-text">Add</span>
        </div>
      </div>
      </div>
    }
    @if (selectedItems.length > 1 && selectedItems.length < maxCompetitors) {
    <div class="selector-item">
    <div class="add-competitor-chip" (click)="onAddSingleCompetitor()" matTooltip="Add competitor" matTooltipPosition="below">
      <div class="chip-content">
        <mat-icon class="add-icon">add</mat-icon>
        <span class="chip-text placeholder-text">Add</span>
      </div>
    </div>
    </div>
    }
    -->
    @if (entityType === 'brand') {
      <div class="selector-item add-competitor-action">
        <button
          mat-icon-button
          class="add-competitor-icon-btn"
          type="button"
          (click)="openAddCompetitorDialog()"
          matTooltip="Add Competitor"
          matTooltipPosition="below">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    }
  </div>
</div>

